<template>
	<div class="index_main">

		<!-- <SkeletonScreen :data="5" v-if="!isCloseSkeletonScreen"/> -->

		<div class="m_item" v-for="(item,i) in list" :key="item.user_id" @click="openMes(item.user_id)">
			<div class="m_img">
				<img :src="item.avatar" />
			</div>
			<p>{{item.nickname}}</p>

			<!-- 小秘书加在线标识 -->

			<div class="online" v-if="item.user_id == 1000 && item.little_secretary_online == 1"></div>

			<div class="m_tag" v-if=" item.unread_number > 0">{{item.unread_number}}</div>
			<div class="m_i" v-else>
				<img  src="https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/img/index/right_i.png" />
			</div>
		</div>

		<loading class="loadbox" loadType="small" :title="'正在加载中...'" v-show="isLoading && hasMore"></loading>
		<no-data msg="没有更多数据了" v-if="!hasMore"></no-data>
		<agqFooter></agqFooter>
	</div>

</template>

<script>
	import agqFooter from "@/components/agpFooter";
	import mesApi from "@/api/message";
	import TIM from 'tim-js-sdk';
	import TIMUploadPlugin from 'tim-upload-plugin';	
	import COS from 'cos-js-sdk-v5';
	import scrollLoad from "@/utils/scrollLoad";
	import myApi from "@/api/my";
    export default {
        name: "message",
		components:{
			agqFooter,
		},
		data(){
        	return{
				list:[],
				hasMore: true,
				isLoading: false,
				compare_to: 0,
				isCloseSkeletonScreen: false,
				user:{},//
			}
		},
		created(){
			this.getMes();
			this.center();
		},
		mounted() {
			this.listenScrollFn();
		},
		methods:{
			async center(){
        		let res = await myApi.center({
					//login_user_id: 1,
				});
        		console.log(res)
				if (res.status === "success") {
					this.user = res.data;
					this.getIVToken();
				} else {
					this.$message.error(res.message);
				}
			},
        	async getMes(){
				if(this.compare_to){
					this.isLoading = true;
				}
        		let res = await mesApi.getMesList({
					user_id:1,
					compare_to:this.compare_to,
				});
				if (res.status === "success") {

					let list = res.data;


					if (list.length!==0) {						

						//首次加载
						if(this.compare_to == 0){
							this.list = list;
						}
						else{
							this.list = [...list,...this.list];
						}

						this.compare_to = list[list.length - 1].sort_time;

					}

					if (list.length === 0) {
						this.hasMore = false;
					}



				} 
				else {
					this.hasMore = false;
					this.$message.error(res.message);
				}
				this.isLoading = false;
				this.isCloseSkeletonScreen = true;
				
			},
			listenScrollFn() {
				window.onscroll = scrollLoad(this.columnListMore);
			},
			//更多
			async columnListMore() {
				if (this.isLoading || this.compare_to === 0 || !this.hasMore) {
					return;
				}
				await this.getMes();
			},
        	openMes(id){
				if(id == 997){
					location.href = `/myComment`
				}
				else{
					location.href = `/mes/${id}`
				}
			},
			refresh(){
				this.compare_to = 0;
				// this.list = [];
				// this.isCloseSkeletonScreen = false;
				// this.hasMore = true;
				// this.isLoading = false;
				window.scrollTo(0,0);
				this.getMes();
			},
			async getIVToken(){
				let CURRENT_ENV_PRE_d = process.env.NODE_ENV;
				let _this = this;
				console.log(CURRENT_ENV_PRE_d)
				let options = {
					SDKAppID: CURRENT_ENV_PRE_d === 'development' || CURRENT_ENV_PRE_d === 'dev' ? 1400317686 : 1400630965 // 接入时需要将0替换为您的即时通信应用的 SDKAppID
				};
				let tim = TIM.create(options); // SDK 实例通常用 tim 表示
				let res = await mesApi.getIVToken();
				console.log('getIVToken',res);
				if (res.status == "success") {
					let sDKS = res.data;
					// 登录

					tim.login({
						userID: `igq-${this.user.user_id}`,
						userSig: sDKS
					}).then(() => {})
					
					// 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
					tim.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
					// tim.setLogLevel(1); // release级别，SDK 输出关键信息，生产环境时建议使用
					tim.registerPlugin({ 'cos-js-sdk': COS, 'tim-upload-plugin': TIMUploadPlugin })//注册COS SDK插件
					
					// 监听事件 收到离线消息和会话列表同步完毕通知
					tim.on(TIM.EVENT.SDK_READY, onReadyStateUpdate, this)
					
					// 收到SDK进入not ready状态通知,此时SDK无法正常工作
					tim.on(TIM.EVENT.SDK_NOT_READY, onReadyStateUpdate, this)
					
					// 出错统一处理
					tim.on(TIM.EVENT.ERROR, onError, this)
					
					// 收到推送的消息,遍历event.data获取消息列表数据并渲染到页面
					tim.on(TIM.EVENT.MESSAGE_RECEIVED, messageReceived, this)
					
					function onReadyStateUpdate ({ name }) {
						const isSDKReady = name === TIM.EVENT.SDK_READY ? true : false;
						if (isSDKReady) {
							tim
								.getMyProfile()
								.then(({ data }) => {
									console.info('登录');
								})
								.catch(error => {})
						}
					}
					
					function onError (event) {
						// 网络错误不弹toast && sdk未初始化完全报错
						if (event.data.message && event.data.code && event.data.code !== 2800 && event.data.code !== 2999) {
						console.info('onerror_+_____')
						}
					}
					
					//消息收发
					function messageReceived (event) {
						console.log('消息收发',event)
						setTimeout(() => {
							//重新刷新一下
							console.log('重新刷新一下')
							setTimeout(() => {
								_this.refresh();
							}, 100);
						}, 100);
						
					}

				} else {
					//this.$message.error(res.message);
				}
			}
		}
    }
</script>

<style scoped lang="scss">
	.index_main{
		background: #FFFFFF;
		min-height: 100vh;
		background: #FFFFFF;
		padding-bottom: 50px;
		padding-top: 10px;
		box-sizing: border-box;
		.m_item{
			position: relative;
			height: 63px;
			margin: 0 12px 11px;
			display: flex;
			align-items: center;
			.m_img{
				width: 52px;
				height: 52px;
				>img{
					width: 100%;
					height: 100%;
					border-radius: 50%;
				}
			}
			>p{
				font-size: 17px;
				font-weight: 400;
				color: #333333;
				margin-left: 12.5px;
			}

			.online{
				width: 34.5px;
				height: 18px;
				background: url('https://cdncos.aigupiao.com/assets/wap/img/chattingRoom/online.png') no-repeat;
				background-size: 100%;
				margin-left: 9.5px;
			}
			.m_tag{
				width: 20px;
				height: 20px;
				background: #FE484A;
				border-radius: 11px;
				font-size: 13px;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 20px;
				text-align: center;
				position: absolute;
				right: 0;
			}
			.m_i{
				width: 10px;
				height: 15px;
				position: absolute;
				right: 0;
				>img{
					width: 100%;
					height: 100%;
				}
			}
		}
	}

</style>
